// Round I — één locatiefilter voor Bibliotheek, Mijn kluis en Beheer → Opnames.
// Het matcht de locatie van de SPREKER (user_location) of een locatie die in de memo
// genoemd wordt (locations). De twee worden nooit samengevoegd.
export const ANY_LOCATION = "__alle_locaties__";
export const LOCATION_FILTER_HINT = "Toont memo's van die locatie én memo's die erover gaan.";

export function matchesLocation(item, location) {
  if (!location || location === ANY_LOCATION) return true;
  const key = location.trim().toLowerCase();
  if ((item?.user_location || "").trim().toLowerCase() === key) return true;
  return (item?.locations || []).some((l) => (l || "").trim().toLowerCase() === key);
}

export function locationOptions(items) {
  const seen = new Map();
  (items || []).forEach((item) => {
    [item?.user_location, ...(item?.locations || [])].forEach((name) => {
      const clean = (name || "").trim();
      if (clean && !seen.has(clean.toLowerCase())) seen.set(clean.toLowerCase(), clean);
    });
  });
  return [...seen.values()].sort((a, b) => a.localeCompare(b));
}
